<template>
  <div class="image-cell">
    <button class="add-btn" v-if="!hasImages" @click="openImageUploadModal">
      <div style="position: relative">
        <img
          :class="{ 'error-border': getHasImageError }"
          src="@/assets/images/icons/add-image.svg"
          alt="Görsel Ekle"
        />
        <img
          class="plus"
          :class="{ 'error-border': getHasImageError }"
          src="@/assets/images/icons/plus.svg"
          alt="Görsel Ekle"
        />
      </div>
      Görsel Ekle
    </button>

    <div
      v-if="imageList.length"
      class="thumbnails"
      @click="openImageUploadModal"
    >
      <div :key="sortedImages[0].id" class="thumbnail-item add-btn">
        <div class="thumbnail-container">
          <img
            :src="sortedImages[0].url"
            :alt="`Image ${sortedImages[0].order}`"
            class="thumbnail"
          />
          <span class="images-length" v-if="sortedImages.length > 1"
            >+{{ sortedImages.length - 1 }}</span
          >
        </div>
        Görsel Ekle / Düzenle
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  pid: {
    type: [String, Number],
    required: true,
  },
  data: {
    type: Array,
    required: false,
    default: () => [],
  },
});

const store = useStore();

const imageList = computed(() => props.data || []);
const sortedImages = computed(() =>
  [...imageList.value].sort((a, b) => a.order - b.order)
);
const hasImages = computed(() => imageList.value.length > 0);
const getHasImageError = computed(
  () => store.getters["common/getHasImageError"]
);

const openImageUploadModal = () => {
  store.commit("products/SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID", props.pid);
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.image-cell {
  .add-btn {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    cursor: pointer;
    color: $colorM50;
    font: 600 12px/16px "Open Sans", sans-serif;
    position: relative;

    img:not(.plus) {
      border: 1px solid var(--Dusk---Decorative-D20, #d3d6df);
      border-radius: 8px;
      height: 64px;
      width: 64px;
    }

    .plus {
      position: absolute;
      right: -6px;
      top: -6px;
      border-radius: 999px !important;
      width: 20px;
      height: 20px;
    }
    .error-border {
      border: 2px solid #ff3939 !important;
      border-radius: 8px;
    }
  }

  .thumbnails {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
  }

  .thumbnail-item {
    overflow: hidden;

    .thumbnail-container {
      position: relative;
    }
  }

  .thumbnail {
    border: 1px solid var(--Dusk---Decorative-D20, #d3d6df);
    width: 64px;
    border-radius: 8px;
    height: 64px;
    object-fit: cover;
  }

  .images-length {
    position: absolute;
    top: 50%;
    right: -25px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font: 600 12px/16px "Open Sans", sans-serif;
    color: var(--Neutral---Background-N80, #374151);
    background-color: var(--Neutral---Background-N20, #f3f4f6);
    border: 1px solid var($colorD30, #b3bbcb);
    border-radius: 50%;
  }
}
</style>
